/* Shared option-list styles for Select and Combobox — no owning component. */

.positioner {
	z-index: var(--zindex-popup);
}

/* Base UI's dismiss backdrop ships no z-index and would land under a Modal (1050),
   letting the dismiss click through. It is the only portal child with
   role="presentation" and no data-slot. Keep the slot list explicit: a
   [data-slot$="-portal"] match would also hit modal-portal. */
:global([data-slot="select-portal"] > [role="presentation"]:not([data-slot])),
:global([data-slot="combobox-portal"] > [role="presentation"]:not([data-slot])) {
	z-index: var(--zindex-popup-backdrop);
}

/* The var() fallbacks matter: an inline list (Combobox.Root `inline`) has no positioner,
   and without them the whole declaration is invalid. */
.popup {
	box-sizing: border-box;
	min-width: var(--anchor-width, 0);
	max-width: var(--available-width, 100%);
	padding: var(--list-spacing) 0;
	font-size: var(--font-size-base);
	background-color: var(--dropdown-bg);
	border: 1px solid var(--dropdown-border);
	background-clip: padding-box;
	border-radius: var(--input-border-radius);
	box-shadow: var(--dropdown-shadow);
	outline: 0;
	max-height: min(250px, var(--available-height, 100vh)); /* app-wide menu cap */
	overflow-y: auto;
}

.item {
	padding: calc(var(--padding-base-y) + 1px) var(--content-padding-base); /* 8px 15px */
	margin-bottom: 1px;
	line-height: var(--line-height-base);
	color: var(--dropdown-link-color);
	cursor: pointer;
	outline: 0;
	overflow: hidden;
}

.item:last-child {
	margin-bottom: 0;
}

.itemText {
	/* display/flex only matter for Combobox, whose ItemText is an inline <span>. */
	display: block;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	flex: 1;
	min-width: 0;
}

.item[data-highlighted] {
	background-color: var(--dropdown-link-hover-bg);
}

.item[data-selected] {
	color: var(--dropdown-link-active-color);
	background-color: var(--dropdown-link-active-bg);
}

.item[data-disabled] {
	color: var(--dropdown-link-disabled-color);
	background-color: transparent;
	cursor: var(--cursor-disabled);
}

/* Multi-select rows: neutral row plus a checkmark gutter instead of Select's inverted
   brand row, so the keyboard cursor stays visible over selected rows. */
.item[data-multiple] {
	display: flex;
	align-items: center;
	gap: var(--padding-base-y);
}

.item[data-multiple][data-selected] {
	color: var(--dropdown-link-color);
	background-color: transparent;
}

.item[data-multiple][data-highlighted] {
	background-color: var(--dropdown-link-hover-bg);
}

.groupLabel {
	padding: calc(var(--padding-base-y) + 1px) var(--content-padding-base);
	margin-top: var(--list-spacing);
	font-size: var(--font-size-mini);
	line-height: var(--line-height-mini);
	color: var(--text-muted);
	text-transform: uppercase;
}

.separator {
	height: 1px;
	margin: var(--list-spacing) 0;
	overflow: hidden;
	background-color: var(--dropdown-divider-bg);
}
